export type BlogLanguage = 'en-us' | 'ar-ae';

export type BlogCategoryLanguage = 'en-us' | 'ar-ae';

export interface BlogTranslation {
  id: string;
  blog_id: string;
  language: BlogLanguage;
  title: string;
  content: string;
  seo_title: string;
  keywords: string;
  meta_description: string;
  desktop_cover_url: string;
  mobile_cover_url: string;
  createdAt: string;
  updatedAt: string;
}

export interface Blog {
  id: string;
  slug: string;
  category_type: string;
  category_id: string;
  time_read: number;
  is_active: boolean;
  is_featured: boolean;
  published_at: string;
  createdAt: string;
  updatedAt: string;
  deleted_at: string | null;
  translations: BlogTranslation[];
  category_name: string;
}

export interface BlogCategoryTranslation {
  id: string;
  blog_category_id: string;
  language: BlogCategoryLanguage;
  name: string;
  description: string;
  createdAt: string;
  updatedAt: string;
}

export interface BlogCategory {
  id: string;
  slug: string;
  is_active: boolean;
  createdAt: string;
  updatedAt: string;
  deleted_at: string | null;
  translations: BlogCategoryTranslation[];
}

export interface BlogCategoryTranslationPayload {
  language: BlogCategoryLanguage;
  name: string;
  description: string;
}

export interface BlogCategoryPayload {
  slug: string;
  is_active: boolean;
  translations: BlogCategoryTranslationPayload[];
}

export interface BlogPagination {
  total_records: number;
  total_pages: number;
  page: number;
  limit: number;
}

export interface BlogListResponse {
  pagination: BlogPagination;
  records: Blog[];
}

export interface BlogCategoryListResponse {
  pagination: BlogPagination;
  records: BlogCategory[];
}

export type BlogCategoryType = 'blog' | 'product';

export interface BlogTranslationPayload {
  language: BlogLanguage;
  title: string;
  content: string;
  seo_title: string;
  keywords: string;
  meta_description: string;
  desktop_cover_url: string;
  mobile_cover_url: string;
}

export interface BlogPayload {
  slug: string;
  category_type: BlogCategoryType;
  category_id: number;
  time_read: number;
  is_active: boolean;
  is_featured: boolean;
  published_at: string;
  translations: BlogTranslationPayload[];
}


export interface PublicBlogTranslation {
  language: BlogLanguage;
  title: string;
  desktop_cover_url: string;
  mobile_cover_url: string;
  meta_description: string;
}

export interface PublicBlog {
  id: string;
  slug: string;
  category_type: BlogCategoryType | string;
  category_id: string;
  time_read: number;
  is_active: boolean;
  is_featured: boolean;
  published_at: string;
  createdAt: string;
  updatedAt: string;
  deleted_at: string | null;
  translations: PublicBlogTranslation[];
  category_name: string;
}

export interface PublicBlogListResponse {
  pagination: BlogPagination;
  records: PublicBlog[];
}

/** Slim category shape returned by the public blogs categories API. */
export interface PublicBlogCategory {
  id: string;
  slug: string;
  category_type: BlogCategoryType | string;
  name: string;
}
